
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jowNT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $3izAL = parcelRequire("3izAL");

var $2wCqQ = parcelRequire("2wCqQ");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $5dDC4 = parcelRequire("5dDC4");

var $4zyjT = parcelRequire("4zyjT");

var $a96iv = parcelRequire("a96iv");

var $hjUDQ = parcelRequire("hjUDQ");

var $d6u4w = parcelRequire("d6u4w");

var $4cGll = parcelRequire("4cGll");

var $5KWZf = parcelRequire("5KWZf");

var $cfM7x = parcelRequire("cfM7x");


var $2VNQP = parcelRequire("2VNQP");


var $9JigP = parcelRequire("9JigP");

var $iQkti = parcelRequire("iQkti");


var $1NMjw = parcelRequire("1NMjw");











var $f8dGE = parcelRequire("f8dGE");


var $lSFbL = parcelRequire("lSFbL");


var $hiHdh = parcelRequire("hiHdh");

const $dae55fe169396767$var$fetchLocalIdMacroParameters = (editorActions, localId)=>editorActions?.getNodeByLocalId?.(localId)?.toJSON()?.attrs?.parameters ?? null;
const $dae55fe169396767$export$b1b4e692d3acce68 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { localId: localId, editorActions: editorActions } = t0;
    let t1;
    if ($[0] !== editorActions || $[1] !== localId) {
        t1 = ()=>$dae55fe169396767$var$fetchLocalIdMacroParameters(editorActions, localId);
        $[0] = editorActions;
        $[1] = localId;
        $[2] = t1;
    } else t1 = $[2];
    const [spotlightParameters, setSpotlightParameters] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[3] !== editorActions || $[4] !== localId) {
        t2 = ()=>{
            setSpotlightParameters($dae55fe169396767$var$fetchLocalIdMacroParameters(editorActions, localId));
        };
        t3 = [
            editorActions,
            localId
        ];
        $[3] = editorActions;
        $[4] = localId;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] !== editorActions) {
        t4 = (updates)=>{
            setSpotlightParameters((prevParams)=>{
                if (!prevParams) return null;
                const updatedSpotlightParams = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(prevParams);
                updates.forEach((t5)=>{
                    const { path: path, value: value } = t5;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($lSFbL)))(updatedSpotlightParams, path, value);
                });
                (0, $hiHdh.updateNodeParameters)(editorActions, updatedSpotlightParams);
                return updatedSpotlightParams;
            });
        };
        $[7] = editorActions;
        $[8] = t4;
    } else t4 = $[8];
    const updateParameter = t4;
    let t5;
    if ($[9] !== updateParameter) {
        t5 = (path_0)=>(value_0)=>updateParameter([
                    {
                        path: path_0,
                        value: value_0
                    }
                ]);
        $[9] = updateParameter;
        $[10] = t5;
    } else t5 = $[10];
    const createUpdater = t5;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[11] !== createUpdater) {
        t6 = createUpdater("height");
        t7 = createUpdater("backgroundColor");
        t8 = createUpdater("cornerRadius");
        t9 = createUpdater("cornerStyle");
        t10 = createUpdater("layout");
        t11 = createUpdater("content.text.title");
        t12 = createUpdater("content.text.description");
        t13 = createUpdater("content.text.textColor");
        t14 = createUpdater("content.button.isButtonShown");
        t15 = createUpdater("content.button.text");
        t16 = createUpdater("content.button.link");
        t17 = createUpdater("content.button.style");
        $[11] = createUpdater;
        $[12] = t10;
        $[13] = t11;
        $[14] = t12;
        $[15] = t13;
        $[16] = t14;
        $[17] = t15;
        $[18] = t16;
        $[19] = t17;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    } else {
        t10 = $[12];
        t11 = $[13];
        t12 = $[14];
        t13 = $[15];
        t14 = $[16];
        t15 = $[17];
        t16 = $[18];
        t17 = $[19];
        t6 = $[20];
        t7 = $[21];
        t8 = $[22];
        t9 = $[23];
    }
    let t18;
    if ($[24] !== updateParameter) {
        t18 = (imageSrc, altText)=>{
            updateParameter([
                {
                    path: "content.image.imageSrc",
                    value: imageSrc
                },
                {
                    path: "content.image.altText",
                    value: altText
                }
            ]);
        };
        $[24] = updateParameter;
        $[25] = t18;
    } else t18 = $[25];
    let t19;
    if ($[26] !== t10 || $[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== t14 || $[31] !== t15 || $[32] !== t16 || $[33] !== t17 || $[34] !== t18 || $[35] !== t6 || $[36] !== t7 || $[37] !== t8 || $[38] !== t9) {
        t19 = {
            updateHeight: t6,
            updateBackgroundColor: t7,
            updateCornerRadius: t8,
            updateCornerStyle: t9,
            updateLayout: t10,
            updateContentTextTitle: t11,
            updateContentTextDescription: t12,
            updateContentTextColor: t13,
            updateContentIsButtonShown: t14,
            updateContentButtonText: t15,
            updateContentButtonLink: t16,
            updateContentButtonStyle: t17,
            updateContentImage: t18
        };
        $[26] = t10;
        $[27] = t11;
        $[28] = t12;
        $[29] = t13;
        $[30] = t14;
        $[31] = t15;
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t6;
        $[36] = t7;
        $[37] = t8;
        $[38] = t9;
        $[39] = t19;
    } else t19 = $[39];
    const spotlightActions = t19;
    let t20;
    if ($[40] !== spotlightActions || $[41] !== spotlightParameters) {
        t20 = {
            spotlightParameters: spotlightParameters,
            spotlightActions: spotlightActions
        };
        $[40] = spotlightActions;
        $[41] = spotlightParameters;
        $[42] = t20;
    } else t20 = $[42];
    return t20;
} : ({ localId: localId, editorActions: editorActions })=>{
    const [spotlightParameters, setSpotlightParameters] = (0, $cozmU.useState)(()=>$dae55fe169396767$var$fetchLocalIdMacroParameters(editorActions, localId));
    (0, $cozmU.useEffect)(()=>{
        setSpotlightParameters($dae55fe169396767$var$fetchLocalIdMacroParameters(editorActions, localId));
    }, [
        editorActions,
        localId
    ]);
    const updateParameter = (0, $cozmU.useCallback)((updates)=>{
        setSpotlightParameters((prevParams)=>{
            if (!prevParams) return null;
            const updatedSpotlightParams = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(prevParams);
            updates.forEach(({ path: path, value: value })=>(0, (/*@__PURE__*/$parcel$interopDefault($lSFbL)))(updatedSpotlightParams, path, value));
            (0, $hiHdh.updateNodeParameters)(editorActions, updatedSpotlightParams);
            return updatedSpotlightParams;
        });
    }, [
        editorActions
    ]);
    const createUpdater = (path_0)=>(value_0)=>updateParameter([
                {
                    path: path_0,
                    value: value_0
                }
            ]);
    const spotlightActions = {
        updateHeight: createUpdater('height'),
        updateBackgroundColor: createUpdater('backgroundColor'),
        updateCornerRadius: createUpdater('cornerRadius'),
        updateCornerStyle: createUpdater('cornerStyle'),
        updateLayout: createUpdater('layout'),
        updateContentTextTitle: createUpdater('content.text.title'),
        updateContentTextDescription: createUpdater('content.text.description'),
        updateContentTextColor: createUpdater('content.text.textColor'),
        updateContentIsButtonShown: createUpdater('content.button.isButtonShown'),
        updateContentButtonText: createUpdater('content.button.text'),
        updateContentButtonLink: createUpdater('content.button.link'),
        updateContentButtonStyle: createUpdater('content.button.style'),
        updateContentImage: (imageSrc, altText)=>{
            updateParameter([
                {
                    path: 'content.image.imageSrc',
                    value: imageSrc
                },
                {
                    path: 'content.image.altText',
                    value: altText
                }
            ]);
        }
    };
    return {
        spotlightParameters: spotlightParameters,
        spotlightActions: spotlightActions
    };
};



var $fwVKa = parcelRequire("fwVKa");




const $b13b3f255c4e2aaa$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    buttonFieldLabel: {
        id: "company-hub.spotlight-extension.config-panel.button-field.label",
        defaultMessage: "Button text"
    },
    buttonFieldPlaceholder: {
        id: "company-hub.spotlight-extension.config-panel.button-field.placeholder",
        defaultMessage: "Add button text"
    },
    title: {
        id: "company-hub.spotlight-extension.config-panel.title",
        defaultMessage: "Spotlight"
    },
    preamble: {
        id: "company-hub.spotlight-extension.config-panel.preamble",
        defaultMessage: "Highlight important messages with a visual spotlight. {supportLink}"
    },
    preambleWithoutSupportLink: {
        id: "company-hub.spotlight-extension.config-panel.preamble-without-support-link",
        defaultMessage: "Highlight important messages with a visual spotlight."
    },
    preambleSupportLinkLabel: {
        id: "company-hub.spotlight-extension.config-panel.preamble-link.label",
        defaultMessage: "Learn more about spotlights"
    },
    stylesTabLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label",
        defaultMessage: "Styles"
    },
    contentTabLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.content-tab.label",
        defaultMessage: "Content"
    },
    generalTitle: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.general-title",
        defaultMessage: "General"
    },
    layoutsTitle: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts-title",
        defaultMessage: "Layouts"
    }
});















var $w6R6I = parcelRequire("w6R6I");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $cXCJB = parcelRequire("cXCJB");

var $4yUlE = parcelRequire("4yUlE");

var $h2czO = parcelRequire("h2czO");

var $5ddnJ = parcelRequire("5ddnJ");

var $4sYZY = parcelRequire("4sYZY");







var $1ipaC = parcelRequire("1ipaC");


var $65u5c = parcelRequire("65u5c");

var $e9Sxn = parcelRequire("e9Sxn");


var $4WDWC = parcelRequire("4WDWC");


var $4pBmf = parcelRequire("4pBmf");


var $iJCWb = parcelRequire("iJCWb");


var $eafQX = parcelRequire("eafQX");


var $51SAu = parcelRequire("51SAu");




const $4755d9a47662531b$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    backgroundColor: {
        id: "company-hub.spotlight-extension.spotlight.background.color",
        defaultMessage: "Background color"
    },
    textColor: {
        id: "company-hub.spotlight-extension.spotlight.text.color",
        defaultMessage: "Text color"
    },
    colorValidationSuccessMessage: {
        id: "company-hub.spotlight-extension.spotlight.color-contrast.success",
        defaultMessage: "Your text and background colors work well for readability."
    },
    colorValidationFailMessage: {
        id: "company-hub.spotlight-extension.spotlight.color-contrast.fail",
        defaultMessage: "Your text and background colors don't work well for readability."
    },
    cornerRadius: {
        id: "company-hub.spotlight-extension.spotlight.corner.radius",
        defaultMessage: "Corners"
    }
});


const $edf64de035902eba$var$styles = {
    generalOptionStyles: "_39xV02N91d"
};
const $edf64de035902eba$export$2910923bcc04bf2a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(69);
    const { parameters: parameters, actions: actions } = t0;
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, isCompanyHub: isCompanyHub, branding: branding } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== branding) {
        t1 = branding ?? {};
        $[0] = branding;
        $[1] = t1;
    } else t1 = $[1];
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[2] !== parameters) {
        t2 = parameters ?? {};
        $[2] = parameters;
        $[3] = t2;
    } else t2 = $[3];
    const { backgroundColor: backgroundColorAdf, content: content, cornerStyle: cornerStyle, cornerRadius: cornerRadius } = t2;
    const { updateContentTextColor: updateContentTextColor, updateBackgroundColor: updateBackgroundColor, updateCornerStyle: updateCornerStyle, updateCornerRadius: updateCornerRadius } = actions;
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const isCornerRadiusLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    const { backgroundColorMap: backgroundColorMap, emptyColorMap: emptyColorMap, textColorMap: textColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $4pBmf.useHubTheming)();
    const isAdvancedThemingEnabled = !!theming?.isAdvancedThemingEnabled;
    let t3;
    if ($[4] !== backgroundColorAdf || $[5] !== isAdvancedThemingEnabled || $[6] !== theming) {
        t3 = isAdvancedThemingEnabled && theming ? (0, $e9Sxn.resolveAdfColorForPicker)(backgroundColorAdf, theming.palette, (0, $65u5c.ELEMENT_DEFAULTS)["spotlight.bg"], theming.primaryColor) : backgroundColorAdf;
        $[4] = backgroundColorAdf;
        $[5] = isAdvancedThemingEnabled;
        $[6] = theming;
        $[7] = t3;
    } else t3 = $[7];
    const backgroundColor = t3;
    const textColor = content?.text?.textColor;
    let t4;
    if ($[8] !== textColor) {
        t4 = (color)=>(0, $4yUlE.isReadable)(color, textColor);
        $[8] = textColor;
        $[9] = t4;
    } else t4 = $[9];
    const isReadableBackgroundColor = t4;
    let t5;
    if ($[10] !== backgroundColor) {
        t5 = (color_0)=>(0, $4yUlE.isReadable)(color_0, backgroundColor);
        $[10] = backgroundColor;
        $[11] = t5;
    } else t5 = $[11];
    const isReadableTextColor = t5;
    (0, $5ddnJ.useAutoTransitioningColors)(backgroundColor, isReadableTextColor, textColor, updateContentTextColor, branding?.defaultParameters);
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $w6R6I.cx)($edf64de035902eba$var$styles.generalOptionStyles);
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4755d9a47662531b$export$a7357cdd1f0b0168).backgroundColor));
        $[13] = t7;
    } else t7 = $[13];
    const t8 = hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap;
    let t9;
    if ($[14] !== isAdvancedThemingEnabled || $[15] !== theming || $[16] !== updateBackgroundColor) {
        t9 = (bgColor)=>{
            if (!bgColor) return;
            updateBackgroundColor(isAdvancedThemingEnabled && theming ? theming.toStoredColor(bgColor) : bgColor);
        };
        $[14] = isAdvancedThemingEnabled;
        $[15] = theming;
        $[16] = updateBackgroundColor;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== formatMessage) {
        t10 = formatMessage((0, $4755d9a47662531b$export$a7357cdd1f0b0168).colorValidationSuccessMessage);
        $[18] = formatMessage;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== formatMessage) {
        t11 = formatMessage((0, $4755d9a47662531b$export$a7357cdd1f0b0168).colorValidationFailMessage);
        $[20] = formatMessage;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== backgroundColor || $[23] !== isCompanyHub || $[24] !== isReadableBackgroundColor || $[25] !== t10 || $[26] !== t11 || $[27] !== t8 || $[28] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            builtInColorMap: t8,
            isReadableColor: isReadableBackgroundColor,
            onChange: t9,
            value: backgroundColor,
            pickerTitle: (0, $4755d9a47662531b$export$a7357cdd1f0b0168).backgroundColor,
            validationSuccessMessage: t10,
            validationFailMessage: t11,
            showCustomPalette: isCompanyHub,
            analyticsSource: "spotlightExtensionConfigBackgroundColor"
        }));
        $[22] = backgroundColor;
        $[23] = isCompanyHub;
        $[24] = isReadableBackgroundColor;
        $[25] = t10;
        $[26] = t11;
        $[27] = t8;
        $[28] = t9;
        $[29] = t12;
    } else t12 = $[29];
    let t13;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4755d9a47662531b$export$a7357cdd1f0b0168).textColor));
        $[30] = t13;
    } else t13 = $[30];
    const t14 = isAdvancedThemingEnabled && theming?.brandBackgroundColorMap ? theming.brandBackgroundColorMap : hideDefaultColorPalette ? emptyColorMap : textColorMap;
    let t15;
    if ($[31] !== isAdvancedThemingEnabled || $[32] !== theming || $[33] !== updateContentTextColor) {
        t15 = (color_1)=>{
            if (!color_1) return;
            updateContentTextColor(isAdvancedThemingEnabled && theming ? theming.toStoredColor(color_1) : color_1);
        };
        $[31] = isAdvancedThemingEnabled;
        $[32] = theming;
        $[33] = updateContentTextColor;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== isAdvancedThemingEnabled || $[36] !== textColor || $[37] !== theming) {
        t16 = isAdvancedThemingEnabled && theming ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, theming.palette, (0, $65u5c.ELEMENT_DEFAULTS)["spotlight.bg"], (0, $h2czO.readableTextColor)(theming.primaryColor, "@atlassian/company-hub-common"), theming.primaryColor) : textColor;
        $[35] = isAdvancedThemingEnabled;
        $[36] = textColor;
        $[37] = theming;
        $[38] = t16;
    } else t16 = $[38];
    let t17;
    if ($[39] !== formatMessage) {
        t17 = formatMessage((0, $4755d9a47662531b$export$a7357cdd1f0b0168).colorValidationSuccessMessage);
        $[39] = formatMessage;
        $[40] = t17;
    } else t17 = $[40];
    let t18;
    if ($[41] !== formatMessage) {
        t18 = formatMessage((0, $4755d9a47662531b$export$a7357cdd1f0b0168).colorValidationFailMessage);
        $[41] = formatMessage;
        $[42] = t18;
    } else t18 = $[42];
    let t19;
    if ($[43] !== isCompanyHub || $[44] !== isReadableTextColor || $[45] !== t14 || $[46] !== t15 || $[47] !== t16 || $[48] !== t17 || $[49] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, t13, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            builtInColorMap: t14,
            isReadableColor: isReadableTextColor,
            onChange: t15,
            value: t16,
            pickerTitle: (0, $4755d9a47662531b$export$a7357cdd1f0b0168).textColor,
            validationSuccessMessage: t17,
            validationFailMessage: t18,
            showCustomPalette: isCompanyHub,
            analyticsSource: "spotlightExtensionConfigTextColor",
            showTextIcon: true
        }));
        $[43] = isCompanyHub;
        $[44] = isReadableTextColor;
        $[45] = t14;
        $[46] = t15;
        $[47] = t16;
        $[48] = t17;
        $[49] = t18;
        $[50] = t19;
    } else t19 = $[50];
    let t20;
    if ($[51] !== cornerRadius || $[52] !== cornerStyle || $[53] !== isCompanyHub || $[54] !== isCornerRadiusEnabled || $[55] !== isCornerRadiusLocked || $[56] !== theming?.cornerRadius || $[57] !== updateCornerRadius) {
        t20 = isCompanyHub && isCornerRadiusEnabled && !isCornerRadiusLocked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
            label: (0, $4755d9a47662531b$export$a7357cdd1f0b0168).cornerRadius,
            minValue: (0, $4WDWC.HUB_CORNER_RADIUS_MIN),
            maxValue: (0, $4WDWC.HUB_CORNER_RADIUS_MAX),
            step: (0, $4WDWC.HUB_CORNER_RADIUS_STEP),
            value: (0, $4WDWC.resolveHubCornerRadius)((0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) ?? theming?.cornerRadius),
            updateRangeValue: updateCornerRadius,
            analyticSource: "spotlightExtensionConfigCornerRadius",
            prefix: "cornerRadius",
            unit: "px"
        });
        $[51] = cornerRadius;
        $[52] = cornerStyle;
        $[53] = isCompanyHub;
        $[54] = isCornerRadiusEnabled;
        $[55] = isCornerRadiusLocked;
        $[56] = theming?.cornerRadius;
        $[57] = updateCornerRadius;
        $[58] = t20;
    } else t20 = $[58];
    let t21;
    if ($[59] !== cornerStyle || $[60] !== isCompanyHub || $[61] !== isCornerRadiusEnabled || $[62] !== updateCornerStyle) {
        t21 = isCompanyHub && !isCornerRadiusEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ipaC.CornerStyleConfig), {
            cornerStyleValue: cornerStyle,
            updateCornerStyle: updateCornerStyle,
            roundCornerValue: (0, $hjUDQ.CornerStyle).ROUNDED,
            squareCornerValue: (0, $hjUDQ.CornerStyle).SQUARED
        });
        $[59] = cornerStyle;
        $[60] = isCompanyHub;
        $[61] = isCornerRadiusEnabled;
        $[62] = updateCornerStyle;
        $[63] = t21;
    } else t21 = $[63];
    let t22;
    if ($[64] !== t12 || $[65] !== t19 || $[66] !== t20 || $[67] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            testId: "general-options",
            direction: "column",
            xcss: t6
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t12, t19, t20, t21));
        $[64] = t12;
        $[65] = t19;
        $[66] = t20;
        $[67] = t21;
        $[68] = t22;
    } else t22 = $[68];
    return t22;
} : ({ parameters: parameters, actions: actions })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, isCompanyHub: isCompanyHub, branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { backgroundColor: backgroundColorAdf, content: content, cornerStyle: cornerStyle, cornerRadius: cornerRadius } = parameters ?? {};
    const { updateContentTextColor: updateContentTextColor, updateBackgroundColor: updateBackgroundColor, updateCornerStyle: updateCornerStyle, updateCornerRadius: updateCornerRadius } = actions;
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)(); // Per-element corner radius is Premium, so an un-entitled hub gets no control
    // at all rather than one it could not publish. Scoped to the new flow: the
    // legacy rounded/squared toggle below is not a radius setting and stays.
    const isCornerRadiusLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    const { backgroundColorMap: backgroundColorMap, emptyColorMap: emptyColorMap, textColorMap: textColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    // useHubTheming returns undefined in cross-host trees (Confluence Company
    // Hub) that don't mount <HubThemingProvider>. The narrowing below treats
    // "no theming" as gate-OFF — the v2 picker code paths only run when theming
    // is present AND the gate is enabled, so `palette` is always defined inside
    // those branches.
    const theming = (0, $4pBmf.useHubTheming)();
    const isAdvancedThemingEnabled = !!theming?.isAdvancedThemingEnabled; // Picker path: resolve through the JS palette so the indicator hex matches
    // one of the picker's `knownColors` (it can't reverse-lookup CSS-var refs).
    // When the gate is OFF, pass the ADF value straight to the picker — matches
    // pre-v2 behaviour.
    const backgroundColor = isAdvancedThemingEnabled && theming ? (0, $e9Sxn.resolveAdfColorForPicker)(backgroundColorAdf, theming.palette, (0, $65u5c.ELEMENT_DEFAULTS)['spotlight.bg'], theming.primaryColor) : backgroundColorAdf;
    const textColor = content?.text?.textColor;
    const isReadableBackgroundColor = (color)=>(0, $4yUlE.isReadable)(color, textColor);
    const isReadableTextColor = (color_0)=>(0, $4yUlE.isReadable)(color_0, backgroundColor);
    (0, $5ddnJ.useAutoTransitioningColors)(backgroundColor, isReadableTextColor, textColor, updateContentTextColor, branding?.defaultParameters);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        testId: "general-options",
        direction: "column",
        xcss: (0, $w6R6I.cx)($edf64de035902eba$var$styles.generalOptionStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4755d9a47662531b$export$a7357cdd1f0b0168).backgroundColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
        isReadableColor: isReadableBackgroundColor,
        onChange: (bgColor)=>{
            if (!bgColor) return; // When v2 is on, persist as a PaletteRef when the picked
            // hex matches a brand-palette shade so it tracks future
            // brand-color edits. Otherwise persist whatever the picker
            // emitted — matches pre-v2 behaviour exactly.
            updateBackgroundColor(isAdvancedThemingEnabled && theming ? theming.toStoredColor(bgColor) : bgColor);
        },
        value: backgroundColor,
        pickerTitle: (0, $4755d9a47662531b$export$a7357cdd1f0b0168).backgroundColor,
        validationSuccessMessage: formatMessage((0, $4755d9a47662531b$export$a7357cdd1f0b0168).colorValidationSuccessMessage),
        validationFailMessage: formatMessage((0, $4755d9a47662531b$export$a7357cdd1f0b0168).colorValidationFailMessage),
        showCustomPalette: isCompanyHub,
        analyticsSource: "spotlightExtensionConfigBackgroundColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4755d9a47662531b$export$a7357cdd1f0b0168).textColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        builtInColorMap: isAdvancedThemingEnabled && theming?.brandBackgroundColorMap ? theming.brandBackgroundColorMap : hideDefaultColorPalette ? emptyColorMap : textColorMap,
        isReadableColor: isReadableTextColor,
        onChange: (color_1)=>{
            if (!color_1) return;
            updateContentTextColor(isAdvancedThemingEnabled && theming ? theming.toStoredColor(color_1) : color_1);
        },
        value: isAdvancedThemingEnabled && theming ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, theming.palette, (0, $65u5c.ELEMENT_DEFAULTS)['spotlight.bg'], (0, $h2czO.readableTextColor)(theming.primaryColor, '@atlassian/company-hub-common'), theming.primaryColor) : textColor,
        pickerTitle: (0, $4755d9a47662531b$export$a7357cdd1f0b0168).textColor,
        validationSuccessMessage: formatMessage((0, $4755d9a47662531b$export$a7357cdd1f0b0168).colorValidationSuccessMessage),
        validationFailMessage: formatMessage((0, $4755d9a47662531b$export$a7357cdd1f0b0168).colorValidationFailMessage),
        showCustomPalette: isCompanyHub,
        analyticsSource: "spotlightExtensionConfigTextColor",
        showTextIcon: true
    })), isCompanyHub && isCornerRadiusEnabled && !isCornerRadiusLocked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
        label: (0, $4755d9a47662531b$export$a7357cdd1f0b0168).cornerRadius,
        minValue: (0, $4WDWC.HUB_CORNER_RADIUS_MIN),
        maxValue: (0, $4WDWC.HUB_CORNER_RADIUS_MAX),
        step: (0, $4WDWC.HUB_CORNER_RADIUS_STEP),
        value: (0, $4WDWC.resolveHubCornerRadius)((0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) ?? theming?.cornerRadius),
        updateRangeValue: updateCornerRadius,
        analyticSource: "spotlightExtensionConfigCornerRadius",
        prefix: "cornerRadius",
        unit: "px"
    }), isCompanyHub && !isCornerRadiusEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ipaC.CornerStyleConfig), {
        cornerStyleValue: cornerStyle,
        updateCornerStyle: updateCornerStyle,
        roundCornerValue: (0, $hjUDQ.CornerStyle).ROUNDED,
        squareCornerValue: (0, $hjUDQ.CornerStyle).SQUARED
    })));
};






var $3ricL = parcelRequire("3ricL");





var $9DHhW = parcelRequire("9DHhW");


var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $4o0zT = parcelRequire("4o0zT");


var $kz1Yj = parcelRequire("kz1Yj");








var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $8mmUh = parcelRequire("8mmUh");








var $6QFPB = parcelRequire("6QFPB");


var $7J77p = parcelRequire("7J77p");


var $jT39w = parcelRequire("jT39w");


var $9gEtC = parcelRequire("9gEtC");




const $a326c3687cb3bcb3$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    titleLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.text-title-label",
        defaultMessage: "Title"
    },
    descriptionLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.text-description-label",
        defaultMessage: "Description"
    },
    imageLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.text-image-label",
        defaultMessage: "Image"
    },
    titlePlaceholder: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder",
        defaultMessage: "Give your spotlight a title"
    },
    descriptionPlaceholder: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder",
        defaultMessage: "Spotlights highlight important messages for your team. Design your spotlight with an image, your custom colors, a short description, and a link."
    },
    aiGenerationErrorFlagTitle: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.ai-generation.error.flag.title",
        defaultMessage: "We couldn't generate your image"
    },
    aiGenerationErrorFlagDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.ai-generation.error.flag.description",
        defaultMessage: "Try again or choose a different image."
    },
    aiGenerationErrorFlagDescriptionWithReason: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.ai-generation.error.flag.description-with-reason",
        defaultMessage: "{errorReason}. Try again or choose a different image."
    }
});


const $db5ce82af2ab14cd$var$wrapperStyles = (0, $buxP3.xcss)({
    paddingBlock: 'space.100'
});
const $db5ce82af2ab14cd$export$cc923a32c7b3f62a = ({ parameters: parameters, actions: actions, contentId: contentId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, enableLinkInputInMediaPicker: enableLinkInputInMediaPicker } = (0, $cfM7x.useProductDependencies)();
    // Gate the Premium Extensions image generation experiment behind the
    // `confluence-ai` feature so that AI-related UI is suppressed for IC
    // (Isolated Cloud) tenants where Confluence AI is not available.
    const isAiImgGenEnabled = (0, $4o0zT.isExperimentEnabled)('cc_page_experiences_premium_macros_img_generation') && (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    const { generateImage: generateImage, aiHeaderImageFileId: aiHeaderImageFileId, aiHeaderImageStatus: aiHeaderImageStatus, error: aiHeaderImageError } = (0, $6QFPB.useCompanyHubImageGeneration)({
        contentId: contentId
    });
    const isTranslationEnabled = (0, $9gEtC.useIsTranslationSupportEnabled)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = intl;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Fire an analytics event when an AI-generated header image has been
    // produced successfully. We fire once per generation by tracking when
    // `aiHeaderImageFileId` transitions from falsy to truthy. Mirrors the
    // `headerImageAdded` analytics fired by Confluence's
    // EditorPageCoverPicture.handleAIGeneratedUpload, but adapted for the
    // spotlight extension config panel.
    const prevAIHeaderImageFileIdRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!isAiImgGenEnabled) {
            prevAIHeaderImageFileIdRef.current = aiHeaderImageFileId;
            return;
        }
        const prevFileId = prevAIHeaderImageFileIdRef.current;
        const isNewFileId = !prevFileId && !!aiHeaderImageFileId;
        prevAIHeaderImageFileIdRef.current = aiHeaderImageFileId;
        if (!isNewFileId) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'added',
                actionSubject: 'image',
                actionSubjectId: 'companyHubImageAdded',
                source: 'spotlightExtension',
                attributes: {
                    imageSource: 'aiGenerated',
                    imageId: aiHeaderImageFileId,
                    inputMethod: 'configPanel',
                    aiHeaderImageStatus: aiHeaderImageStatus,
                    isAIImgGenEnabled: isAiImgGenEnabled
                }
            }
        }).fire();
    }, [
        aiHeaderImageFileId,
        aiHeaderImageStatus,
        isAiImgGenEnabled,
        createAnalyticsEvent
    ]);
    // Surface a flag to the user when AI image generation fails. We only fire
    // when the status transitions INTO `ERROR` (mirroring the Confluence header
    // image behaviour in EditorPageCoverPicture) so re-renders while already in
    // the error state don't produce duplicate flags.
    //
    // Each fire uses a unique flag `id` so that consecutive failures STACK in
    // the flag tray (matching the Confluence header image behaviour) rather
    // than replacing the previous flag — ADS `useFlags` dedupes by `id`.
    const prevAIHeaderImageStatusRef = (0, $cozmU.useRef)(null);
    const aiGenerationErrorFlagCounterRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        if (!isAiImgGenEnabled) {
            prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
            return;
        }
        const prevStatus = prevAIHeaderImageStatusRef.current;
        const isTransitioningToError = prevStatus !== 'ERROR' && aiHeaderImageStatus === 'ERROR';
        prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
        if (!isTransitioningToError) return;
        const description = aiHeaderImageError ? formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).aiGenerationErrorFlagDescriptionWithReason, {
            errorReason: aiHeaderImageError
        }) : formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).aiGenerationErrorFlagDescription);
        aiGenerationErrorFlagCounterRef.current += 1;
        showFlag({
            id: `spotlight-extension-ai-generation-error-flag-${aiGenerationErrorFlagCounterRef.current}`,
            title: formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).aiGenerationErrorFlagTitle),
            description: description,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        });
    }, [
        aiHeaderImageStatus,
        aiHeaderImageError,
        isAiImgGenEnabled,
        showFlag,
        formatMessage
    ]);
    const { content: { text: { title: title, description: description }, image: image, button: { text: buttonText, link: buttonLink, style: buttonStyle } }, layout: layout } = parameters;
    const { updateContentTextTitle: updateContentTextTitle, updateContentTextDescription: updateContentTextDescription, updateContentImage: updateContentImage, updateContentButtonText: updateContentButtonText, updateContentButtonLink: updateContentButtonLink, updateContentIsButtonShown: updateContentIsButtonShown, updateContentButtonStyle: updateContentButtonStyle } = actions;
    const isAiHeaderImageLoading = (aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW') && !aiHeaderImageFileId;
    const generateImageRef = (0, $cozmU.useRef)(generateImage);
    generateImageRef.current = generateImage;
    const generateAndApplyImage = (0, $cozmU.useCallback)(async (props)=>{
        const mediaFileId = await generateImageRef.current(props);
        if (mediaFileId) updateContentImage(mediaFileId, '');
        return mediaFileId;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        updateContentImage
    ]);
    const handleFieldAnalytics = (0, $cozmU.useCallback)((fieldType, label)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'focused',
                actionSubject: fieldType,
                actionSubjectId: `configPanel${label}TextField`,
                source: 'spotlightExtensionConfig'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleChangeTitle = (0, $cozmU.useCallback)((event)=>{
        updateContentTextTitle(event.currentTarget.value);
    }, [
        updateContentTextTitle
    ]);
    const handleChangeDescription = (0, $cozmU.useCallback)((event)=>{
        updateContentTextDescription(event.currentTarget.value);
    }, [
        updateContentTextDescription
    ]);
    const handleChangeImage = (0, $cozmU.useCallback)((props)=>{
        const imageSrc = 'fullSizeImageUrl' in props ? props.fullSizeImageUrl : props.uploadedImageId;
        const altText = props.altDescription;
        updateContentImage(imageSrc, altText);
    }, [
        updateContentImage
    ]);
    const handleChangeLink = (0, $cozmU.useCallback)((linkPayload)=>{
        if (!buttonLink) updateContentIsButtonShown(true);
        updateContentButtonLink(linkPayload.url);
    }, [
        updateContentButtonLink,
        updateContentIsButtonShown,
        buttonLink
    ]);
    const handleClearLink = (0, $cozmU.useCallback)(()=>{
        updateContentButtonLink('');
        updateContentIsButtonShown(false);
    }, [
        updateContentButtonLink,
        updateContentIsButtonShown
    ]);
    const handleRemoveButton = (0, $cozmU.useCallback)(()=>{
        updateContentButtonLink('');
        updateContentButtonStyle((0, $hjUDQ.ButtonStyle).DEFAULT);
        updateContentButtonText('');
        updateContentIsButtonShown(false);
    }, [
        updateContentButtonLink,
        updateContentIsButtonShown,
        updateContentButtonText,
        updateContentButtonStyle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.200",
        xcss: $db5ce82af2ab14cd$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).titleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        maxLength: 100,
        value: title,
        onChange: handleChangeTitle,
        onFocus: ()=>handleFieldAnalytics('textField', 'Title'),
        placeholder: intl.formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).titlePlaceholder)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).descriptionLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        minimumRows: 5,
        maxLength: 180,
        value: description,
        onChange: handleChangeDescription,
        onFocus: ()=>handleFieldAnalytics('textArea', 'Description'),
        placeholder: intl.formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).descriptionPlaceholder)
    })), layout !== (0, $hjUDQ.CommonLayout).NO_IMAGE_BACKGROUND && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).imageLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jT39w.MediaPickerSection), {
        shouldAllowLinkFromUrl: enableLinkInputInMediaPicker,
        contentId: contentId,
        image: image,
        onChangeImage: handleChangeImage,
        analyticsSource: "spotlightExtension",
        generateAIHeaderImage: isAiImgGenEnabled ? generateAndApplyImage : undefined,
        isAiHeaderImageLoading: isAiImgGenEnabled ? isAiHeaderImageLoading : false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8mmUh.ButtonConfig), {
        cloudId: cloudId,
        link: buttonLink,
        text: buttonText,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-1876
        style: buttonStyle,
        updateButtonText: updateContentButtonText,
        updateButtonStyle: updateContentButtonStyle,
        handleClearButton: handleRemoveButton,
        handleClearLink: handleClearLink,
        handleSelectLink: handleChangeLink,
        source: "spotlightExtension"
    }), isTranslationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7J77p.ManageTranslationsButton), {
        extensionType: (0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE)
    }));
};



const $62e751f38a3eb836$var$SOURCE = 'spotlightExtensionConfig';
const $62e751f38a3eb836$var$SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/highlight-important-messages-with-a-visual-spotlight/';
const $62e751f38a3eb836$var$stickyFooterStyles = (0, $buxP3.xcss)({
    paddingInline: 'space.050',
    paddingBlock: 'space.200',
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    bottom: 'space.0',
    backgroundColor: 'elevation.surface'
});
const $62e751f38a3eb836$var$SpotlightFooter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $62e751f38a3eb836$var$stickyFooterStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
            source: "spotlightExtension",
            type: (0, $hjUDQ.FeedbackType).SPOTLIGHT
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $62e751f38a3eb836$var$stickyFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
        source: "spotlightExtension",
        type: (0, $hjUDQ.FeedbackType).SPOTLIGHT
    }));
const $62e751f38a3eb836$export$148c1178eb706663 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(59);
    const { closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions, extensionKey: extensionKey, contentId: contentId } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { isOpen: isManageTranslationsOpen } = (0, $iQkti.useManageTranslationsOpen)();
    const [selectedTab, setSelectedTab] = (0, $cozmU.useState)(0);
    let t1;
    if ($[0] !== editorActions || $[1] !== localId) {
        t1 = {
            localId: localId,
            editorActions: editorActions
        };
        $[0] = editorActions;
        $[1] = localId;
        $[2] = t1;
    } else t1 = $[2];
    const { spotlightParameters: spotlightParameters, spotlightActions: spotlightActions } = (0, $dae55fe169396767$export$b1b4e692d3acce68)(t1);
    const { showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $cfM7x.useProductDependencies)();
    let t2;
    if ($[3] !== spotlightParameters) {
        t2 = (t3)=>{
            const { height: height, layout: layout } = t3;
            const extensionNode = {
                extensionKey: (0, $1NMjw.SPOTLIGHT_EXTENSION_KEY),
                extensionType: (0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE),
                parameters: {
                    ...spotlightParameters,
                    height: height,
                    layout: layout
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fwVKa.Spotlight), {
                isPreviewSize: true,
                extensionNode: extensionNode
            });
        };
        $[3] = spotlightParameters;
        $[4] = t2;
    } else t2 = $[4];
    const PreviewContentComponent = t2;
    if (!spotlightParameters) {
        let t3;
        if ($[5] !== extensionKey) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6u4w.NoExtensionData), {
                source: extensionKey,
                isConfigPanel: true
            });
            $[5] = extensionKey;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    let t3;
    if ($[7] !== intl) {
        t3 = intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).stylesTabLabel);
        $[7] = intl;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== intl) {
        t4 = intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).generalTitle);
        $[9] = intl;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== spotlightActions || $[12] !== spotlightParameters) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $edf64de035902eba$export$2910923bcc04bf2a), {
            parameters: spotlightParameters,
            actions: spotlightActions
        });
        $[11] = spotlightActions;
        $[12] = spotlightParameters;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = {
            title: t4,
            sectionId: "general",
            defaultIsExpanded: true,
            component: t5
        };
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== intl) {
        t7 = intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).layoutsTitle);
        $[17] = intl;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== PreviewContentComponent || $[20] !== spotlightActions.updateLayout || $[21] !== spotlightParameters.layout) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VNQP.LayoutOptions), {
            updateLayout: spotlightActions.updateLayout,
            source: $62e751f38a3eb836$var$SOURCE,
            layoutOptions: (0, $1NMjw.layoutOptions),
            PreviewComponent: PreviewContentComponent,
            currentLayoutSelection: spotlightParameters.layout
        });
        $[19] = PreviewContentComponent;
        $[20] = spotlightActions.updateLayout;
        $[21] = spotlightParameters.layout;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== t7 || $[24] !== t8) {
        t9 = {
            title: t7,
            sectionId: "layouts",
            defaultIsExpanded: false,
            component: t8
        };
        $[23] = t7;
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[26] !== t6 || $[27] !== t9) {
        t10 = [
            t6,
            t9
        ];
        $[26] = t6;
        $[27] = t9;
        $[28] = t10;
    } else t10 = $[28];
    let t11;
    if ($[29] !== t10 || $[30] !== t3) {
        t11 = {
            label: t3,
            value: "styles",
            tabContent: t10
        };
        $[29] = t10;
        $[30] = t3;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== intl) {
        t12 = intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).contentTabLabel);
        $[32] = intl;
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== contentId || $[35] !== spotlightActions || $[36] !== spotlightParameters) {
        t13 = [
            {
                sectionId: "main",
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
                    grow: "fill",
                    space: "space.200"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db5ce82af2ab14cd$export$cc923a32c7b3f62a), {
                    parameters: spotlightParameters,
                    actions: spotlightActions,
                    contentId: contentId
                }))
            }
        ];
        $[34] = contentId;
        $[35] = spotlightActions;
        $[36] = spotlightParameters;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== t12 || $[39] !== t13) {
        t14 = {
            label: t12,
            value: "content",
            tabContent: t13
        };
        $[38] = t12;
        $[39] = t13;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== t11 || $[42] !== t14) {
        t15 = [
            t11,
            t14
        ];
        $[41] = t11;
        $[42] = t14;
        $[43] = t15;
    } else t15 = $[43];
    const tabSections = t15;
    let t16;
    if ($[44] !== closeConfigPanel || $[45] !== isManageTranslationsOpen || $[46] !== selectedTab || $[47] !== showConfigPreambleSupportLink || $[48] !== tabSections) {
        t16 = !isManageTranslationsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
            closeConfigPanel: closeConfigPanel,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).title),
            footerComponent: $62e751f38a3eb836$var$SpotlightFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...showConfigPreambleSupportLink ? (0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).preamble : (0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).preambleWithoutSupportLink,
            values: {
                supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: $62e751f38a3eb836$var$SUPPORT_LINK
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).preambleSupportLinkLabel))
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cGll.PremiumGateForExtensionConfigPanel), {
            feature: "premiumSpotlightConfig"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zyjT.ConfigPanelGrouping), {
            source: $62e751f38a3eb836$var$SOURCE,
            tabSections: tabSections,
            selected: selectedTab,
            onTabClick: (_tab, index)=>setSelectedTab(index)
        })));
        $[44] = closeConfigPanel;
        $[45] = isManageTranslationsOpen;
        $[46] = selectedTab;
        $[47] = showConfigPreambleSupportLink;
        $[48] = tabSections;
        $[49] = t16;
    } else t16 = $[49];
    let t17;
    if ($[50] !== closeConfigPanel || $[51] !== intl || $[52] !== isManageTranslationsOpen || $[53] !== localId || $[54] !== spotlightParameters) {
        t17 = isManageTranslationsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9JigP.ManageTranslations), {
            parameters: spotlightParameters,
            closeConfigPanel: closeConfigPanel,
            localId: localId,
            extensionType: (0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE),
            config: {
                fields: [
                    {
                        path: "content.text.title",
                        label: intl.formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).titleLabel),
                        placeholder: intl.formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).titlePlaceholder)
                    },
                    {
                        path: "content.text.description",
                        label: intl.formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).descriptionLabel),
                        placeholder: intl.formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).descriptionPlaceholder)
                    },
                    {
                        path: "content.button.text",
                        label: intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).buttonFieldLabel),
                        placeholder: intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).buttonFieldPlaceholder)
                    }
                ]
            }
        });
        $[50] = closeConfigPanel;
        $[51] = intl;
        $[52] = isManageTranslationsOpen;
        $[53] = localId;
        $[54] = spotlightParameters;
        $[55] = t17;
    } else t17 = $[55];
    let t18;
    if ($[56] !== t16 || $[57] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t16, t17);
        $[56] = t16;
        $[57] = t17;
        $[58] = t18;
    } else t18 = $[58];
    return t18;
} : ({ closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions, extensionKey: extensionKey, contentId: contentId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { isOpen: isManageTranslationsOpen } = (0, $iQkti.useManageTranslationsOpen)();
    // Retain the selected tab across the manage-translations mount toggle (HUBS-1411).
    const [selectedTab, setSelectedTab] = (0, $cozmU.useState)(0);
    const { spotlightParameters: spotlightParameters, spotlightActions: spotlightActions } = (0, $dae55fe169396767$export$b1b4e692d3acce68)({
        localId: localId,
        editorActions: editorActions
    });
    const { showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $cfM7x.useProductDependencies)();
    const PreviewContentComponent = (0, $cozmU.useCallback)(({ height: height, layout: layout })=>{
        const extensionNode = {
            extensionKey: (0, $1NMjw.SPOTLIGHT_EXTENSION_KEY),
            extensionType: (0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE),
            // Casting here to satisfy TypeScript and prevent the linter from thinking
            // useCallback is called conditionally.
            parameters: {
                ...spotlightParameters,
                height: height,
                layout: layout
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fwVKa.Spotlight), {
            isPreviewSize: true,
            extensionNode: extensionNode
        });
    }, [
        spotlightParameters
    ]);
    if (!spotlightParameters) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6u4w.NoExtensionData), {
        source: extensionKey,
        isConfigPanel: true
    });
    const tabSections = [
        {
            label: intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).stylesTabLabel),
            value: 'styles',
            tabContent: [
                {
                    title: intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).generalTitle),
                    sectionId: 'general',
                    defaultIsExpanded: true,
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $edf64de035902eba$export$2910923bcc04bf2a), {
                        parameters: spotlightParameters,
                        actions: spotlightActions
                    })
                },
                {
                    title: intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).layoutsTitle),
                    sectionId: 'layouts',
                    defaultIsExpanded: false,
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VNQP.LayoutOptions), {
                        updateLayout: spotlightActions.updateLayout,
                        source: $62e751f38a3eb836$var$SOURCE,
                        layoutOptions: (0, $1NMjw.layoutOptions),
                        PreviewComponent: PreviewContentComponent,
                        currentLayoutSelection: spotlightParameters.layout
                    })
                }
            ]
        },
        {
            label: intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).contentTabLabel),
            value: 'content',
            tabContent: [
                {
                    sectionId: 'main',
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
                        grow: "fill",
                        space: "space.200"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db5ce82af2ab14cd$export$cc923a32c7b3f62a), {
                        parameters: spotlightParameters,
                        actions: spotlightActions,
                        contentId: contentId
                    }))
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !isManageTranslationsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
        closeConfigPanel: closeConfigPanel,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).title),
        footerComponent: $62e751f38a3eb836$var$SpotlightFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...showConfigPreambleSupportLink ? (0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).preamble : (0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).preambleWithoutSupportLink,
        values: {
            supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                target: "_blank",
                href: $62e751f38a3eb836$var$SUPPORT_LINK
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).preambleSupportLinkLabel))
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cGll.PremiumGateForExtensionConfigPanel), {
        feature: "premiumSpotlightConfig"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zyjT.ConfigPanelGrouping), {
        source: $62e751f38a3eb836$var$SOURCE,
        tabSections: tabSections,
        selected: selectedTab,
        onTabClick: (_tab, index)=>setSelectedTab(index)
    }))), isManageTranslationsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9JigP.ManageTranslations), {
        parameters: spotlightParameters,
        closeConfigPanel: closeConfigPanel,
        localId: localId,
        extensionType: (0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE),
        config: {
            fields: [
                {
                    path: 'content.text.title',
                    label: intl.formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).titleLabel),
                    placeholder: intl.formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).titlePlaceholder)
                },
                {
                    path: 'content.text.description',
                    label: intl.formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).descriptionLabel),
                    placeholder: intl.formatMessage((0, $a326c3687cb3bcb3$export$a7357cdd1f0b0168).descriptionPlaceholder)
                },
                {
                    path: 'content.button.text',
                    label: intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).buttonFieldLabel),
                    placeholder: intl.formatMessage((0, $b13b3f255c4e2aaa$export$a7357cdd1f0b0168).buttonFieldPlaceholder)
                }
            ]
        }
    }));
};
const $62e751f38a3eb836$export$9bb8febcc3103da7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iQkti.ManageTranslationsOpenProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($62e751f38a3eb836$export$148c1178eb706663, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iQkti.ManageTranslationsOpenProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($62e751f38a3eb836$export$148c1178eb706663, props));
module.exports["SpotlightConfigPanelContent"] = $62e751f38a3eb836$export$9bb8febcc3103da7;

});


//# sourceMappingURL=spotlight.3e122662.js.map
